import { useTranslation } from "react-i18next";
import { Suspense } from "react";
import { Link, Outlet } from "react-router-dom";
import { useMediaQuery } from "usehooks-ts";

import { Header } from "@/components/layout/header";
import { AppLogo } from "@/components/layout/sidebar/LogoWrapper";
import { RouteFallback } from "@/components/layout/RouteFallback";

const noop = () => {};

// Full-height layout for Studio builders: keeps the app top bar (logo + header)
// but hides the main sidebar, so the builder gets the full width below it. On
// desktop we render the logo here (replacing the sidebar's) and let Header show
// breadcrumbs; below lg, Header renders its own logo, so ours is hidden — this
// avoids the duplicate logo.
const BuilderLayout = () => {
  const { t } = useTranslation(["common"]);
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  return (
    <div className="flex h-screen flex-col overflow-hidden bg-white">
      <div className="flex shrink-0 items-stretch border-b border-border">
        <Link
          to="/"
          aria-label={t("common:a11y.go_to_home")}
          className="hidden items-center border-e border-border px-4 lg:flex"
        >
          <AppLogo />
        </Link>
        <div className="min-w-0 flex-1">
          <Header
            isSidebarOpen
            onToggleSidebar={noop}
            isDesktop={isDesktop}
            noSidebar
          />
        </div>
      </div>
      <main className="min-h-0 flex-1 overflow-hidden">
        <Suspense fallback={<RouteFallback />}>
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
};

export default BuilderLayout;
